import { FilterProp, PanelOption } from 'frontend/types'
import { filterSchoolSubjectClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import { activeOptionLabel } from 'frontend/utils/helpers'
import Panel from './Panel/Panel'
import { SearchParams } from 'backend/services/types/urApiService.types'

type Props = {
  subjectTree: FilterProp[]
  handlePanelClick: () => void
  isOpen: boolean
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
}

const SchoolSubjectAndKnowledgeArea = ({
  subjectTree,
  handlePanelClick,
  isOpen,
  searchParams,
  updateSearch,
}: Props) => {
  const { subject_tree: subjectTreeParams } = searchParams

  const activeLabels = activeOptionLabel(
    [...subjectTree],
    subjectTreeParams || '',
    true,
  )

  const handleOptionSelect = (option: PanelOption) => {
    const isSelected = activeLabels.includes(option.label)

    if (!isSelected) filterSchoolSubjectClick(option.label)

    updateSearch({
      subject_tree: option.value as string,
    })
  }

  return (
    <Panel
      activeLabels={activeLabels}
      ariaLabel="Filtrera på skolämne och kunskapsområde"
      dataTrk="filter-school-subject"
      handlePanelClick={handlePanelClick}
      isOpen={isOpen}
      label="Skolämne och kunskapsområde"
      onOptionSelect={handleOptionSelect}
      options={subjectTree}
    />
  )
}

export default SchoolSubjectAndKnowledgeArea
